import { render, staticRenderFns } from "./DisplayUsers.vue?vue&type=template&id=46e438ee"
import script from "./DisplayUsers.vue?vue&type=script&lang=ts"
export * from "./DisplayUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports